import { createSelector } from 'reselect';
import { StoreState } from 'src/store/reducers';
import { IServiceType } from 'src/types/service-types';

export const Selector = (state: StoreState) => state.serviceTypes.data.list;

export const selectNameSerTypes = createSelector(Selector, (items) => {
    const ids: { [key: string]: string } = {};
    items.forEach((item: IServiceType) => {
        ids[item.id] = item.title ? item.title : item.cpt;
    });

    return ids;
});
export const selectNameServiceTypes = createSelector(Selector, (items) => {
    const arrSel: { label: string; value: number | string }[] = [];
    items.forEach((item: IServiceType) => {
        arrSel.push({ label: item?.title ? item?.title : item?.cpt, value: item.id });
    });

    arrSel.sort((a: SelectObject, b: SelectObject) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    return arrSel;
});
export const selectNameSerTypesDropDown = createSelector(Selector, (items): SelectObject[] => {
    const itemsRes: SelectObject[] = [];
    items.forEach((item: IServiceType) => {
        itemsRes.push({ value: item.id, label: item.title ? item.title : item.cpt });
    });

    return itemsRes;
});
